module.exports = __webpack_public_path__ + "img/defaultProfileImg.4e5a1625.png";